// ABOUTME: What a CHoverCard gives what it shows: closing it at once, and pinning it open while something is typed there.
// ABOUTME: Kept out of the component file, which exports components only (react-refresh).
import { createContext, useContext } from "react"

export interface HoverCardControls {
  /** Shuts it at once: its content has opened something else. */
  close: () => void
  /** While pinned, the pointer going away leaves it open: something is being typed there. */
  pin: (isPinned: boolean) => void
}

export const HoverCardContext = createContext<HoverCardControls | null>(null)

/**
 * Throws outside a card on purpose, as the calendar's registry does: the alternative is a link that opens a window
 * and leaves the card standing over it.
 */
export function useHoverCard(): HoverCardControls {
  const controls = useContext(HoverCardContext)
  if (!controls) throw new Error("useHoverCard: no CHoverCard above — it is for what a hover card shows")
  return controls
}
